function Contact() {
    return (
        <>
            <h1>Hello from Contactpage</h1>
        </>
    );
}

export default Contact;
